import { TravelDirection } from '../../enums/travel-direction.enum';

export const TRAVEL_DIRECTION = {
  [TravelDirection.OneWay]: 'ONE_WAY',
  [TravelDirection.TwoWay]: 'TWO_WAY',
};
